export default "__VITE_ASSET__fc48e3a6__"